/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { createNaN } from '../../factoriesAny.js';
export var NaNDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  createNaN: createNaN
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesNaN.generated.js
// module id = 1463
// module chunks = 0